module.exports = __webpack_public_path__ + "static/media/smile-serenity-shy-emoji-emoticon-svgrepo-com.382016db.svg";